import dayjs from "dayjs";
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

export default dayjs;